





















import { namespace } from 'vuex-class';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CART } from '@/store/types';
import { NumberFormatter } from '@/services/NumberFormatter';
import { Big } from 'big.js';
import { Cart } from '@/services/cart/model/cart';
import { CartEvents } from '@/services/cart/model/cart-events';
import { DependencyService } from '@/services/DependencyService';
import { ProductDto } from '@eurogast/hub-client-typescript';

const cart = namespace(CART);

@Component({
  components: {}
})
export default class CartSummaryHeader extends Vue {
  @cart.State('cart')
  public cart: Cart;

  @Prop({required: false, default: '/my/shopping-cart'})
  public cartUrl: string;

  private cartService = DependencyService.getCartService();

  public mounted() {
    Vue.prototype.$events.$on(CartEvents.CART_UPDATE, () => {
      location.reload();
    });
  }

  @Watch('cart')
  public onCartChange() {
    location.reload();
  }

  get totalPrice() {
    return NumberFormatter.formatPrice(this.cartService.totalPrice);
  }

  get showPrice() {
    return !this.cartService.totalPrice.eq(new Big('0.0'));
  }

  get availableCartItemsLength(): number {
    return this.cart.items.filter((it) => it.product.availability === ProductDto.AvailabilityEnum.ACTIVE).length;
  }
}
